module.exports = __webpack_public_path__ + "media/site/images/banners/banner-development-mobile-69fb2ecae9bf9897e7417728087f926e.svg";